import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FilterTablePlaceholderDirective } from 'src/directive/filter-table-placeholder.directive';
import { Filter } from 'src/components/shared-components/class/general-classes/filter';
import { FiltersType } from 'src/components/shared-components/enum/enumFilters';
import { EventService } from 'src/service/event.service';

@Component({
    selector: 'app-filter-bar',
    templateUrl: './filter-bar.component.html',
    styleUrls: ['./filter-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterBarComponent implements OnInit {
  @Input('Filters') Filters: Filter[] = [];
  @Output('OnFilterRequest') OnFilterRequest = new EventEmitter<Map<string, string>>();

  @ViewChild(FilterTablePlaceholderDirective, { static: true })
  componentFilters: FilterTablePlaceholderDirective;

  private _filtersData = new Map<string, string>();

  constructor(private _eventService: EventService) { }

  ngOnInit() {
    this.componentFilters.drawFiltersComponent(
      this.Filters
    );

    this._eventService.OnFilterValueChanged.subscribe(([filter, value]) => {
      if (filter.Kind == FiltersType.text ||
        filter.Kind == FiltersType.number ||
        filter.Kind == FiltersType.date ||
        filter.Kind == FiltersType.combo ||
        filter.Kind == FiltersType.time) {
        if (value.trim() != "")
          this._filtersData.set(filter.Name, value.trim());
        else
          this._filtersData.delete(filter.Name);
      }
    })
  }

  /**
   * Send data about filter setted
   */
  Filter() {
    this.OnFilterRequest.emit(this._filtersData);
  }

  /**
   * Open popup with filters
   */
  SelectFilter() {
    // open popup filter
  }

}
